import Vue from 'vue'

const luBillableCategory = {
  state: {
    luBillableCategory: [],
    selectedLuBillableCategory: {},
    saving: false,
    searchCount: 0,
  },

  getters: {
    luBillableCategory(state) {
      return state.luBillableCategory
    },
    selectedLuBillableCategory(state) {
      return state.selectedLuBillableCategory
    },
    loading(state) {
      return state.searchCount > 0
    },
  },

  mutations: {
    luBillableCategory(state, payload) {
      state.luBillableCategory = payload
    },
    selectedLuBillableCategory(state, payload) {
      state.selectedLuBillableCategory = JSON.parse(JSON.stringify(payload))
    },
    saving(state, payload) {
      state.saving = payload
    },
    searchCount(state, payload) {
      state.searchCount = payload
    },
    increaseSearchCount(state, payload) {
      state.searchCount = state.searchCount + 1
    },
    decreaseSearchCount(state, payload) {
      state.searchCount = state.searchCount - 1
    },
  },

  actions: {
    setSelectedLuBillableCategory(context, payload) {
      context.commit('selectedLuBillableCategory', payload)
    },
    loadLuBillableCategory(context, payload) {
      return new Promise((resolve, reject) => {
        const url = 'LuBillableCategory'
        context.commit('increaseSearchCount')
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('luBillableCategory', res.data)
            context.commit('decreaseSearchCount')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('decreaseSearchCount')
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
    refreshSelectedLuBillableCategory(context, payload) {
      if (
        context.state.selectedLuBillableCategory &&
        context.state.selectedLuBillableCategory.ID
      ) {
        context.dispatch(
          'loadSelectedLuBillableCategory',
          context.state.selectedLuBillableCategory.ID
        )
      }
    },
    loadSelectedLuBillableCategory(context, payload) {
      if (
        context.state.selectedLuBillableCategory &&
        context.state.selectedLuBillableCategory.ID != payload
      ) {
        context.commit('selected', {})
      }
      return new Promise((resolve, reject) => {
        const url = 'LuBillableCategory/' + payload
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('selectedLuBillableCategory', res.data)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
    clearLookupCacheAndReloadLuBillableCategory(context, payload) {
      caches.delete('apilookup-cache').finally(() => {
        context.dispatch('loadLuBillableCategory')
      })
    },
    updateLuBillableCategory(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `LuBillableCategory/${payload.ID}`
        context.commit('saving', true)
        Vue.prototype.$axios.put(url, payload).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              {color: 'success', message: 'Lu Billable Category updated'},
              {root: true}
            )
            //if you will always need to reload the list after an update
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadLuBillableCategory')
            context.commit('saving', false)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('saving', false)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
    createLuBillableCategory(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `LuBillableCategory`
        context.commit('saving', true)
        Vue.prototype.$axios.post(url, payload).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              {color: 'success', message: 'Lu Billable Category created'},
              {root: true}
            )
            //if you will always need to reload the list after an item is created
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadLuBillableCategory')
            context.commit('saving', false)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.commit('saving', false)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
    saveLuBillableCategory(context, payload) {
      return new Promise((resolve, reject) => {
        if (payload.ID > 0) {
          context.dispatch('updateLuBillableCategory', payload).then(
            (res) => resolve(res),
            (err) => reject(err)
          )
        } else {
          context.dispatch('createLuBillableCategory', payload).then(
            (res) => resolve(res),
            (err) => reject(err)
          )
        }
      })
    },
    deleteLuBillableCategory(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `LuBillableCategory/${payload.ID}`
        Vue.prototype.$axios.delete(url).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              {color: 'success', message: 'Lu Billable Category deleted'},
              {root: true}
            )
            //if you will always need to reload the list after a delete
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadLuBillableCategory')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
  },
}

export default luBillableCategory
